const GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js';

export const loadGapi = () =>
  new Promise<void>((resolve, reject) => {
    if (window.gapi) {
      resolve();
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = GOOGLE_SDK_URL;

    const cleanup = () => {
      scriptTag.removeEventListener('load', load);
      scriptTag.removeEventListener('error', error);
    };

    const load = () => {
      cleanup();
      resolve();
    };

    const error = (e: ErrorEvent) => {
      cleanup();
      reject(e.error);
    };

    scriptTag.addEventListener('load', load);
    scriptTag.addEventListener('error', error);

    document.body.appendChild(scriptTag);
  });
